export const BOOKINGEXPORTOPTIONS = [
    { id: 1, name: "booking: id" },
    { id: 2, name: "student: firstName" },
    { id: 3, name: "student: lastName(familyName)" },
    { id: 4, name: "student: language" },
    { id: 5, name: "student: address" },
    { id: 6, name: "student: city" },
    { id: 7, name: "student: country" },
    { id: 8, name: "student: email" },
    { id: 9, name: "student: parent email" },
    { id: 10, name: "school: name" },
    { id: 11, name: "booking: departure date" },
    { id: 12, name: "booking: return date" },
    { id: 13, name: "duration" },
    { id: 14, name: "active" },
    { id: 15, name: "date: deposit received" },
    { id: 16, name: "destination country"}, 
    { id: 17, name: "agent" },
    { id: 18, name: "student birth date" }
]
